const CloseIcon = () => {
  return (
    <svg
      width="fill"
      height="fill"
      viewBox="0 0 40 40"
      fill="#fff"
      xmlns="http://www.w3.org/2000/svg">
      <g id="Close">
        <path
          id="Vector"
          d="M14.1162 12.5L12.5 14.1162L26.6421 28.2583L28.2584 26.6421L14.1162 12.5Z"
          fill="white"
        />
        <path
          id="Vector_2"
          d="M26.6421 12.5022L12.5 26.6443L14.1162 28.2605L28.2584 14.1184L26.6421 12.5022Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default CloseIcon;
